import React from "react";
import {
  List,
  Datagrid,
  TextField,
  EditButton,
  ChipField,
  SelectField,
  ReferenceField,
  Filter,
  SelectInput,
  ReferenceArrayInput,
  SelectArrayInput,
  TextInput
} from "react-admin";
import Actions from '../Actions'
import { SUPERADMIN } from "../../constant/TypeRole";

const LineFilter = props => {
  const role = localStorage.getItem("role");
  const project = JSON.parse(localStorage.getItem("project"));
  const filter = role ? (role === SUPERADMIN ? {} : { _id: project }) : {};
  return (
    <Filter {...props}>
      <TextInput source="name_contains" />
      <TextInput source="key_contains" />
      <ReferenceArrayInput
        label="โครงการ"
        alwaysOn
        style={{ minWidth: "200px" }}
        source="project"
        reference="project"
        filter={filter}
      >
        <SelectArrayInput optionText="name" />
      </ReferenceArrayInput>
    </Filter>
  );
};

export const LineList = props => {
  const role = localStorage.getItem("role");
  const project = JSON.parse(localStorage.getItem("project"));
  const filter = role ? (role === SUPERADMIN ? {} : { project }) : { project };
  return (
    <List
      {...props}
      title="line.line"
      bulkActions={false}
      actions={<Actions create />}
      filter={filter}
      filters={<LineFilter />}
    >
      <Datagrid>
        <div />
        <ReferenceField linkType={false} source="project" reference="project">
          <ChipField source="name" />
        </ReferenceField>
        <TextField source="name" />
        <TextField source="key" />
        <EditButton />
      </Datagrid>
    </List>
  );
};



// WEBPACK FOOTER //
// ./src/components/line/LineList.js